import moment from "moment";
import { TableContainer, TableHeader, TableTitle, TableBody } from "./style"

interface TableColumn {
    key: string;
    title: string;
}

interface IPropsTableDashboard<T> {
    title: string;
    headerRow: TableColumn[];
    bodyRow?: T[];
}

function formatCellValue(value: any) {
    if (typeof value === "number") {
        return value.toLocaleString();
    }
    if (typeof value === "string" && moment(value, moment.ISO_8601, true).isValid()) {
        return moment(value).format("DD.MM.YYYY HH:mm");
    }
    return value;
}

export const TableDashboard = <T extends Record<string, any>>({ headerRow, bodyRow, title }: IPropsTableDashboard<T>) => {
    return (
        <TableContainer>
            <TableTitle>{title}</TableTitle>
            <TableHeader>
                {headerRow.map((column, index) => (
                    <div key={index}>{column.title}</div>
                ))}
            </TableHeader>
            <TableBody>
                {bodyRow && bodyRow.map((row, index) => (
                    <div className="TableDasboardRow" key={index}>
                        {headerRow.map((column, colIndex) => (
                            <div key={colIndex}>
                                {formatCellValue(row[column.key])}
                            </div>
                        ))}
                    </div>
                ))}
            </TableBody>
        </TableContainer>
    );
};